import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../api/auth'; // ✅ import your new API
import { setAuth } from '../auth';

const Login = ({ setUser, user }) => {
    const [form, setForm] = useState({ username: '', password: '' });
    const [error, setError] = useState('');
    const navigate = useNavigate();

    if (user) {
        navigate('/modules');
        return null;
    }

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const { access_token, token_type, user: userData } = await loginUser(form);

            if (!access_token || !token_type || !userData) {
                setError('Login failed: no token or user info received');
                return;
            }

            setAuth(access_token, token_type, userData);
            setUser(userData);
            navigate('/');
        } catch (err) {
            if (err.response) {
                console.error('API error:', err.response.data);
                setError(err.response.data.error || 'Login failed');
            } else {
                console.error('Network error:', err.message);
                setError('Cannot connect to server');
            }
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
            <form
                onSubmit={handleSubmit}
                className="bg-white p-4 shadow-sm rounded"
                style={{ minWidth: 300 }}
            >
                <h4 className="mb-3 text-center">Login</h4>
                {error && <div className="alert alert-danger">{error}</div>}
                <input
                    type="text"
                    name="username"
                    autoComplete='off'
                    className="form-control mb-2"
                    placeholder="Username"
                    onChange={handleChange}
                />
                <input
                    type="password"
                    name="password"
                    autoComplete='off'
                    className="form-control mb-3"
                    placeholder="Password"
                    onChange={handleChange}
                />
                <button type="submit" className="btn btn-primary w-100">
                    Login
                </button>
            </form>
        </div>
    );
};

export default Login;
